import { useUUIDGenerate } from '@cplug/frontend-core'
import { registerBackend } from '@cplug/frontend-core/gateways'
import { ERP } from '@cplug/frontend-shared-domains/shared'
import { defineNuxtPlugin } from '#app'
import type { ExtendedCPlugAPI } from '~/global/types/runtime-config'
import { AvailableBackendType } from '~/shared/gateways/backends/AvailableBackendType'

class UUIDIdempotencyKeyGenerator {
  generate (): string {
    return useUUIDGenerate()
  }
}

export default defineNuxtPlugin(() => {
  const cplugAPI = useRuntimeConfig().public.cplugAPI as ExtendedCPlugAPI
  const baseURL = cplugAPI.baseURL

  registerBackend('default', () => new ERP(baseURL, new UUIDIdempotencyKeyGenerator(), cplugAPI.withCredentials))
  registerBackend(AvailableBackendType.ERP, () => new ERP(baseURL, new UUIDIdempotencyKeyGenerator(), cplugAPI.withCredentials))
})
